import * as React from 'react';
import { SVGProps } from 'react';

const SvgAssemblyExplorer = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5548_6770)'>
        <path
          d='M22.5 15V9H16.5V11.25H12.75V5.25C12.75 4.85218 12.592 4.47064 12.3107 4.18934C12.0294 3.90804 11.6478 3.75 11.25 3.75H7.5V1.5H1.5V7.5H7.5V5.25H11.25V19.5C11.25 19.8978 11.408 20.2794 11.6893 20.5607C11.9706 20.842 12.3522 21 12.75 21H16.5V23.25H22.5V17.25H16.5V19.5H12.75V12.75H16.5V15H22.5ZM6 6H3V3H6V6ZM18 18.75H21V21.75H18V18.75ZM18 10.5H21V13.5H18V10.5Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_5548_6770'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAssemblyExplorer;
